// hooks/useDownloadFile.ts
import { useCallback, useState } from "react";
import type { FileItem } from "@services/api";
import { useAuthContext } from "@app/authContext";

const BASE_URL: string = (window as any).FZ_API_BASE_URL;

export function useDownloadFile() {
  const { auth } = useAuthContext();
  const accessToken = auth?.access_token ?? "";
  const [loading, setLoading] = useState(false);

  const download = useCallback(async (file: FileItem) => {
    if (!file?.fileId || !file.fileId.trim()) {
      throw new Error("Invalid FileItem: fileId is missing");
    }

    try {
      setLoading(true);

      const url = `${BASE_URL}/front-agent/document/file/${file.fileId}`;
      const res = await fetch(url, {
        method: "GET",
        headers: accessToken
          ? { Authorization: `Bearer ${accessToken}` }
          : undefined,
      });

      if (!res.ok) throw new Error(`Download failed with status ${res.status}`);

      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = file.fileName || `file-${file.fileId}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(objectUrl);
    } finally {
      setLoading(false);
    }
  }, [accessToken]);

  return { download, loading };
}
